export default __webpack_public_path__ + "static/media/leval_2.8076422c.png";